module.exports = __webpack_public_path__ + "static/img/shield-1.54f35e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shield-1.svg
// module id = ebG7
// module chunks = 1